module.exports = __webpack_public_path__ + "img/title3.e6f2f482.png";